// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function PaypalCheckout(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'PaypalCheckout',
      'aria-hidden': true,
      focusable: false,
      width: 44 * scale,
      height: 38 * scale,
      viewBox: '0 0 44 38',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: '#000',
      opacity: '.4',
      fillRule: 'evenodd',
      d: 'M0 0h44v38H0V0zm1 1v36h42V1H1z',
      clipRule: 'evenodd',
    }),
    createElement('path', {
      fill: 'currentColor',
      opacity: '.2',
      fillRule: 'evenodd',
      d: 'M1 1h42v36H1V1z',
      clipRule: 'evenodd',
    }),
    createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M41 12V8h2v4h-2zm0 2h2v4h-2v-4zm0 6h2v4h-2v-4zm0 6h2v4h-2v-4zm0 6h2v5h-5v-2h3v-3zm-5 3v2h-4v-2h4zm-6 0v2h-4v-2h4zm-6 0v2h-4v-2h4zm-6 0v2h-4v-2h4zm-6 0v2H8v-2h4zm-6 0v2H1v-5h2v3h3zm-3-5H1v-4h2v4zm0-6H1v-4h2v4zm0-6H1v-4h2v4zm0-6H1V8h2v4zm0-6H1V1h5v2H3v3zm5-3V1h4v2H8zm6 0V1h4v2h-4zm6 0V1h4v2h-4zm6 0V1h4v2h-4zm6 0V1h4v2h-4zm6 0V1h5v5h-2V3h-3z',
      clipRule: 'evenodd',
    }),
    createElement('path', {
      fill: 'currentColor',
      opacity: '.68',
      d: 'M29.275 14.081c.244-1.556-.002-2.614-.843-3.573C27.505 9.452 25.832 9 23.69 9h-6.216a.89.89 0 00-.878.75l-2.589 16.414c-.05.324.2.617.527.617h3.838l-.265 1.68a.467.467 0 00.46.539h3.236a.778.778 0 00.768-.657l.032-.164.61-3.864.038-.214a.778.778 0 01.769-.657h.484c3.133 0 5.587-1.273 6.304-4.955.3-1.538.145-2.822-.648-3.725a3.082 3.082 0 00-.885-.683z',
    }),
    createElement('path', {
      fill: 'currentColor',
      opacity: '.7',
      d: 'M29.275 14.081c.244-1.556-.002-2.614-.843-3.573C27.505 9.452 25.832 9 23.69 9h-6.216a.89.89 0 00-.878.75l-2.589 16.414c-.05.324.2.617.527.617h3.838l.964-6.113-.03.192a.886.886 0 01.875-.751h1.824c3.582 0 6.387-1.455 7.206-5.664.025-.124.046-.245.064-.364z',
    }),
    createElement('path', {
      fill: 'currentColor',
      d: 'M20.371 14.102a.778.778 0 01.769-.657h4.872c.578 0 1.116.038 1.608.117a7.014 7.014 0 01.797.178 4.393 4.393 0 01.858.342c.244-1.556-.001-2.615-.843-3.574C27.505 9.452 25.832 9 23.69 9h-6.216a.89.89 0 00-.878.75l-2.589 16.414c-.05.324.2.617.527.617h3.838l.964-6.113 1.035-6.566z',
    })
  );
}
